import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import "./Styles/Global.css";
import AboutUs from "./Pages/AboutUs";
import MyProperty from "./Pages/MyProjects";
import Services from "./Pages/Service";
import ResidentDetailPage from "./Pages/DetailPage/ResidentDetailPage";
import RentDetailPage from "./Pages/DetailPage/RentDetailPage";
import CommercialDetailPage from "./Pages/DetailPage/CommercialDetailPage";
import ContactUs from "./Components/Forms/Contactus";
import Footer from "./Components/Footer";
import Blog from "./Pages/Blog/Blog";
import BlogDetail from "./Pages/Blog/BlogDetail";
import AllCommentsPage from "./Pages/Blog/AllCommentPage";
import ScrollToTop from "./Components/ScrollToTop";
import TermsAndConditions from "./Components/TermsAndConditions";
import Events from "./Pages/Events";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Hero from "./Components/Home_Components/Hero";
import PremiumPicks from "./Components/Home_Components/PremiumPicks";
import OurHustle from "./Components/Home_Components/OurHustle";
import PropertySectionv from "./Components/Home_Components/PropertySectionv";
import PromoBanner from "./Components/Home_Components/PromoBannor";
import MediaUpdates from "./Components/Home_Components/MediaUpdates";
import StatsSection from './Components/Home_Components/StatsSection';
import ExcellenceSection from './Components/Home_Components/ExcellenceSection';
import Testimonials from './Components/Home_Components/Testimonials';
function App() {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/my-projects" element={<MyProperty />} />
        <Route path="/events" element={<Events />} />
        <Route path="/our-services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/blogs/:blogId/comments" element={<AllCommentsPage />} />
        <Route
          path="/residential-property/:id"
          element={<ResidentDetailPage />}
        />
        <Route path="/rent-property/:id" element={<RentDetailPage />} />
        <Route
          path="/commercial-property/:id"
          element={<CommercialDetailPage />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/hero" element={<Hero />} />
        <Route path="/premium-picks" element={<PremiumPicks />} />
        <Route path="/our-hustle" element={<OurHustle />} />
        <Route path="/property-sectionv" element={<PropertySectionv />} />
        <Route path="/promo-banner" element={<PromoBanner />} />
        <Route path="/media-updates" element={<MediaUpdates />} />
        <Route path="/stats-section" element={<StatsSection />} />
        <Route path="/excellence-section" element={<ExcellenceSection />} />
        <Route path="/testimonials" element={<Testimonials />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
